import { FC, lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { PageSpinner } from 'src/components/spinner-container';
import { ExternalTradesEntry } from 'src/pages/reporting/secondary-tradings/external-trades';
import { useHasExternalTrades } from 'src/pages/reporting/secondary-tradings/overview/use-has-external-trades';
import {
  remitReportingSubscriptionInfoLoading,
  useRemitReportingSubscriptionInfo,
} from 'src/pages/reporting/secondary-tradings/overview/use-remit-reporting-subscription-info';
import { usePlatformSettings } from 'src/pages/reporting/use-platform-settings';

const Page = lazy(() => import('./page'));

export const ReportingSecondaryTradings: FC = () => {
  const platformSettings = usePlatformSettings();
  const hasExternalTrades = useHasExternalTrades();
  const subscriptionInfoRequest =
    useRemitReportingSubscriptionInfo('SECONDARY');

  if (
    !platformSettings.loaded ||
    !hasExternalTrades.loaded ||
    remitReportingSubscriptionInfoLoading(subscriptionInfoRequest)
  ) {
    return <PageSpinner />;
  }

  return (
    <Switch>
      <Route
        path={[
          '/reporting/secondary',
          '/reporting/secondary/trades',
          '/reporting/secondary/external-trades',
          '/reporting/secondary/external-trades-legacy',
          '/reporting/secondary/proposals',
          '/reporting/secondary/remit-reporting',
        ]}
        exact
      >
        <Page
          platformSettings={platformSettings}
          hasLegacyExternalTrades={!!hasExternalTrades.response?.data}
          subscriptionInfo={subscriptionInfoRequest?.response?.data}
        />
      </Route>
      <Route path="/reporting/secondary/external-trades/*">
        <ExternalTradesEntry />
      </Route>
    </Switch>
  );
};
